export default {
    greeting: 'Welcome to Sedho-Login',
    language_choose: 'Choose a language',
    languages: {
        german: 'German',
        english: 'English',
    },
    menue: {
        admin: 'Admin',
    },
    submenu: {
        user: 'User',
    }
  };